import { z } from "zod";
import {
  CAMPAIGN_MEMBER_SEGMENTS,
  SURVEY_QUESTION_TYPES,
  SURVEY_STATUSES,
} from "../constants/index";
import { nonEmpty } from "./_primitives";

export const surveyQuestionInputSchema = z.object({
  prompt: nonEmpty,
  type: z.enum(SURVEY_QUESTION_TYPES),
  // Choices for single_choice / multi_choice questions.
  options: z.array(z.string().trim().min(1)).optional(),
  required: z.boolean().default(false),
});

export const createSurveySchema = z.object({
  name: nonEmpty,
  description: z.string().trim().optional(),
  status: z.enum(SURVEY_STATUSES).default("draft"),
  audienceSegment: z.enum(CAMPAIGN_MEMBER_SEGMENTS).nullable().optional(),
  questions: z.array(surveyQuestionInputSchema).default([]),
});

export const updateSurveySchema = z.object({
  name: nonEmpty.optional(),
  description: z.string().trim().nullable().optional(),
  status: z.enum(SURVEY_STATUSES).optional(),
  audienceSegment: z.enum(CAMPAIGN_MEMBER_SEGMENTS).nullable().optional(),
  // When provided, REPLACES the full question set.
  questions: z.array(surveyQuestionInputSchema).optional(),
});

// CEO Rev 1.0 Phase 2 — viewer submits answers: { [questionId]: answer }.
export const submitSurveyResponseSchema = z.object({
  answers: z.record(z.string(), z.unknown()),
});

export type SurveyQuestionInput = z.infer<typeof surveyQuestionInputSchema>;
export type CreateSurveyInput = z.infer<typeof createSurveySchema>;
export type UpdateSurveyInput = z.infer<typeof updateSurveySchema>;
export type SubmitSurveyResponseInput = z.infer<typeof submitSurveyResponseSchema>;
